<template>
    <v-breadcrumbs class="pt-3 pb-3" :items="items" dense></v-breadcrumbs>
</template>

<script>
export default {
    name: "breadNav",
    data() {
        return {
            items: [],
        };
    },
    mounted() {
        this.items = this.$route.meta.bread;
    },
};
</script>
